import * as Yup from "yup";
import { validationErrors } from "./validationRules.js";
import validationUtils from "./ValidationUtils.js";

const resetPasswordSchema = Yup.object().shape({
  password: validationUtils?.validatePassword(),
  password_confirm: Yup.string()
    .required(validationErrors?.getRequiredField("confirm password"))
    .test(
      "passwords-match",
      validationErrors?.password?.notMatch,
      function (value) {
        // Only check match if both fields have values
        return !value || this?.parent?.password === value;
      }
    ),
});

export default resetPasswordSchema;